<template lang="pug">
BasePopup(v-if="isOpened" @close="close(false)")
  .b-user-select-popup
    h2._title {{ title ? title : 'Контакты' }}
    BaseInput(v-model="searchString" label="Поиск по имени или e-mail")
    BaseTabs._tabs(:tabs="$options.tabs" big grey v-model="activeTab" v-if="multiple")
    ._users
      EmptyList(v-if="!usersFiltered.length") {{ emptyTitle ? emptyTitle : 'Нет контактов' }}
      ._user(v-for="user in usersFiltered")
        UserTile(:user="user")
        ._status
          ._selected(v-if="isSelectedExternal(user)") Выбран
          Btn(sm grey transparent v-else-if="isSelectedInternal(user)" @click="uncheck(user)") Отменить
          Btn(sm green v-else @click="check(user)") Выбрать
    ._buttons
      Btn(@click="close(true)") Сохранить
      Btn(@click="close(false)" grey) Отмена
</template>

<script>
import teamApi from '@/api/team';

import BaseSelect from '@/components/BaseSelect.vue';
import BasePopup from '@/components/BasePopup.vue';
import BaseTabs from '@/components/BaseTabs.vue';
import BaseInput from '@/components/BaseInput.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import UserTile from '@/components/UserTile.vue';
import EmptyList from '@/components/ui/EmptyList.vue';

/**
 * TODO: устаревший вариант выбора пользователя — открывается через ref или
 * позиционные args и рисует собственный BasePopup, из-за чего его нельзя
 * открыть как wrappable-попап. На замену есть UserSelectPopupWrappable с той
 * же логикой, но с обычным для проекта интерфейсом (params + init + finish).
 * В будущем всю систему нужно перевести на него, а этот компонент удалить;
 * пока он используется в ProjectMembers, DepartmentTile,
 * CompanyDepartmentListPage и TeamMemberFormPopupWrappable.
 */
export default {
  name: 'UserSelectPopup2',
  components: {
    EmptyList,
    UserTile,
    BaseCheckbox,
    BaseInput,
    BaseTabs,
    BasePopup,
    BaseSelect,
  },
  controller: null,
  tabs: [
    { value: 'all', label: 'Все' },
    { value: 'checked', icon: 'checked' },
    { value: 'unchecked', icon: 'unchecked' },
  ],
  data() {
    return {
      isOpened: false,
      activeTab: 'all',
      searchString: '',
      multiple: false,
      selectedExternal: null,
      selectedInternal: null,
      customUserSet: null,
      title: '',
      emptyTitle: '',
    };
  },
  created() {
    this.$store.dispatch('contact/fetchItems');
  },
  computed: {
    contacts() {
      return this.customUserSet ?? this.$store.getters['contact/users'];
    },
    usersFiltered() {
      return this.contacts.filter((user) => {
        const searchString = this.searchString.toLowerCase().replace(/ /g, '');
        const userSearchString = ((user.name ?? '') + (user.surname ?? '') + user.email).toLowerCase();
        const fitsBySearchString = !searchString || userSearchString.includes(searchString);

        const userIsSelected = this.isSelectedExternal(user) || this.isSelectedInternal(user);
        const fitsByTabs = this.activeTab === 'all'
          || (this.activeTab === 'checked' && userIsSelected)
          || (this.activeTab === 'unchecked' && !userIsSelected);

        return fitsBySearchString && fitsByTabs;
      });
    },
  },
  methods: {
    isSelectedExternal(user) {
      return this.selectedExternal.includes(user['@id']);
    },
    isSelectedInternal(user) {
      return this.multiple
        ? this.selectedInternal.includes(user['@id'])
        : this.selectedInternal?.['@id'] === user['@id'];
    },
    check(user) {
      this.selectedInternal = this.multiple
        ? [...this.selectedInternal, user['@id']]
        : user;
    },
    uncheck(user) {
      this.selectedInternal = this.multiple
        ? this.selectedInternal.filter((u) => u !== user['@id'])
        : null;
    },
    open(selected, multiple = false, customUserSet = null, title = 'Контакты', emptyTitle = 'Нет контактов') {
      this.selectedInternal = multiple ? [] : null;
      this.selectedExternal = selected;
      this.isOpened = true;
      this.multiple = multiple;
      this.customUserSet = customUserSet;
      this.title = title;
      this.emptyTitle = emptyTitle;

      return new Promise((resolve, reject) => {
        this.$options.controller = { resolve, reject };
      });
    },
    close(saveResult) {
      const result = this.multiple
        ? this.contacts.filter((u) => this.isSelectedInternal(u))
        : this.contacts.find((u) => this.isSelectedInternal(u));

      this.$options.controller.resolve(saveResult ? result || null : null);

      this.isOpened = false;
      this.selectedInternal = null;
      this.selectedExternal = null;
    },
  },
};
</script>

<style scoped lang="scss">
.user-select-popup {
  width: 450px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;

  &__title {
    font-size: 24px;
    line-height: 24px;
    color: var(--color-super-dark);
  }

  &__users {
    overflow-y: scroll;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    gap: 13px;
    max-height: calc(100vh - 370px);
    height: 500px;
    padding-bottom: 7px;
  }

  &__user {
    display: flex;
    gap: 17px;
  }

  &__status {
    margin-left: auto;
    width: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__selected {
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.01em;
    color: #788CA1;
    font-weight: normal;
  }

  &__buttons {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
  }
}
</style>
